// extracted by mini-css-extract-plugin
var _1 = "SubscribeTodayDisclaimer_disclaimer__f5wcd";
export { _1 as "disclaimer" }
